import { render, staticRenderFns } from "./composer-ferramentas.vue?vue&type=template&id=348dffb4&scoped=true&"
import script from "./composer-ferramentas.vue?vue&type=script&lang=js&"
export * from "./composer-ferramentas.vue?vue&type=script&lang=js&"
import style0 from "./composer-ferramentas.vue?vue&type=style&index=0&id=348dffb4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348dffb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348dffb4')) {
      api.createRecord('348dffb4', component.options)
    } else {
      api.reload('348dffb4', component.options)
    }
    module.hot.accept("./composer-ferramentas.vue?vue&type=template&id=348dffb4&scoped=true&", function () {
      api.rerender('348dffb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/composer-ferramentas/composer-ferramentas.vue"
export default component.exports